// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {getPastelColor} from '../../../../utils/style';
import {Typography} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';

import type {CustomerCategory} from '../../../../entities';

type Props = {
  category?: CustomerCategory,
  thin?: boolean,
};

const useStyles = makeStyles(theme => ({
  root: {
    border: '1px solid #E8E8ED',
    padding: theme.spacing(1, 2),
    borderRadius: '20px',
  },
  textCategory: {
    color: colors.grey800,
    fontWeight: 500,
    fontSize: '14px',
  },
}));

export default function CustomCategoryChip(props: Props) {
  const {category, thin = true} = props;
  const classes = useStyles();

  if (!category) return null;
  return (
    <div
      className={classes.root}
      style={{
        backgroundColor: getPastelColor(category.color),
        padding: thin ? '4px 16px' : '8px 16px',
      }}
    >
      <Typography className={classes.textCategory}>{category.name}</Typography>
    </div>
  );
}

CustomCategoryChip.propTypes = {
  category: PropTypes.object,
  thin: PropTypes.bool,
};
